import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BrandLogo from './BrandLogo';
import UserMenu from './UserMenu';
import { MvLandscape, SEARCH_CURVE } from './brand/MvLandscape';

function Header({
  showSearch = false,
  onOpenAi,
}) {
  const { t } = useTranslation();

  return (
    <header className="top">
      <Link
        to="/"
        className="logo"
        aria-label={t('header.logoAriaLabel')}
      >
        <BrandLogo />
      </Link>

      {showSearch && (
        <button
          className="search-box"
          type="button"
          onClick={onOpenAi}
          aria-label={t('header.searchAriaLabel')}
        >
          <i className="fa-solid fa-magnifying-glass" />
          <span>{t('header.searchPlaceholder')}</span>
        </button>
      )}

      <UserMenu />

      <MvLandscape
  className="top-landscape"
  bands={[
    {
      color: 'var(--header-band)',
      top: 30,
      amplitude: 60,
      flip: true,
      baseCurve: SEARCH_CURVE,
    },
  ]}
  lines={[
    {
      color: 'var(--mv-sonnengelb)',
      top: 8,
      amplitude: 60,
      flip: true,
      width: 2,
    },
  ]}
/>
    </header>
  );
}

export default Header;
